<template>
  <div class="parking-space-config app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>车场状态</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.status" class="app-block" placeholder="请选择车场状态">
              <a-select-option :value="1">启用</a-select-option>
              <a-select-option :value="0">禁用</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>应用社区</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.community" class="app-block" placeholder="请选择应用社区">
              <a-select-option :value="value.id" v-for="value in communityOptions" :key="value.id">{{value.name}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newConfig()">新增配置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="state" slot-scope="text, data">
        <a-switch :checked="data.status === 1" :loading="data.stateLoading" @click="stateChange(data)"></a-switch>
      </template>
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="editConfig(data)">编辑</a-button>
        </a-space>
      </template>
    </a-table>
    <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal" destroy-on-close centered>
      <a-form-model ref="modalForm" :model="modal.form" layout="vertical" :rules="modal.rules">
        <a-form-model-item label="应用社区" prop="community">
          <a-select v-model="modal.form.community" placeholder="请选择应用社区" :disabled="modal.isEdit">
            <a-select-option :value="value.id" v-for="value in communityOptions" :key="value.id">{{value.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="停车场ID" prop="id">
          <a-input v-model="modal.form.id" placeholder="请输入停车场ID" allow-clear></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import CommunityService from '@/io/community.js';
  import ParkingSpaceConfigService from '@/io/parking_space_config.js';

  export default {
    name: 'ParkingSpaceConfig',
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {
            status: [],
            community: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '社区名称',
              dataIndex: 'community'
            },
            {
              title: '停车场ID',
              dataIndex: 'park_key'
            },
            {
              title: '所在区域',
              dataIndex: 'region'
            },
            {
              title: '车位总数',
              dataIndex: 'park_info[0].totalLot'
            },
            {
              title: '剩余数',
              dataIndex: 'park_info[0].idleLot'
            },
            {
              title: '状态',
              scopedSlots: { customRender: 'state' },
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        communityOptions: [],
        modal: {
          isEdit: false,
          title: null,
          show: false,
          loading: false,
          form: {
            community: [],
            id: null
          },
          rules: {
            community: [
              {
                required: true,
                message: '请选择应用社区'
              }
            ],
            id: [
              {
                required: true,
                message: '请填写停车场ID'
              }
            ]
          }
        },
      }
    },
    activated () {
      this.initCommunity().then(() => {
        this.initData();
      });
    },
    methods: {
      stateChange(data) {
        let checked = data.status === 1;
        data.stateLoading = true;
        ParkingSpaceConfigService[checked ? 'disable' : 'enable'](data.id, data.park_key).then(res => {}).catch(err => {}).finally(() => {
          this.$afterFormSubmit(checked ? '关闭成功' : '开启成功');
          data.status = checked ? 0 : 1;
          data.stateLoading = false;
        });
      },
      newConfig() {
        this.modal.title = '添加配置';
        this.modal.form.community = [];
        this.modal.form.id = null;
        this.modal.show = true;
        this.modal.isEdit = false;
      },
      editConfig(data) {
        this.modal.title = '编辑配置';
        this.modal.form.community = data.community_id;
        this.modal.form.id = data.park_key;
        this.modal.show = true;
        this.modal.isEdit = true;
      },
      confirmModal() {
        this.$beforeFormSubmit(this.$refs.modalForm, () => {
          this.modal.loading = true;
          ParkingSpaceConfigService.config(this.modal.form.community, this.modal.form.id, this.communityOptions.filter(m => this.modal.form.community === m.id)[0].name).then(res => {
            this.$afterFormSubmit('配置成功', () => {
              this.initData();
            });
          }).catch(err => {}).finally(() => {
            this.modal.show = false;
            this.modal.loading = false;
          });
        });
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          status: [],
          community: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initCommunity() {
        return CommunityService.listPage().then(res => {
          this.communityOptions = res;
        }).catch(err => {});
      },
      initData() {
        this.table.loading = true;
        ParkingSpaceConfigService.listPage(
          this.table.search.status,
          this.table.search.community,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            let community = this.communityOptions.filter(m => val.community_id === m.id)[0];
            val.community = community.name;
            val.region = `${community.province} / ${community.city} / ${community.area}`;
            val.stateLoading = false;
            return val;
          });
          this.table.page.total = res.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>